import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import SeoHelmets from '../../SeoOptimazation/SeoHelmets';
import CardsPage from '../../CardsPage/CardsPage';
import TwoRowThreeColumnLayout from '../../EffectonLoad/TwoThreecolumnLayout';
import { fetchCourseCard as fetchCoursesByExamBody } from '../../DynamicCourse/api';
import axios from 'axios';
import { BASE_URL } from '../../../insightConfig/insightConfig';

function CivilsCard() {
  const civilheading = "CIVILS COURSES"
  const [testsData, setTestsData] = useState([]);
  useEffect(() => {
    // Fetch data from API
    const fetchData = async () => {
      try {
        const response = await axios.get(BASE_URL + '/ExamBody/civils');


        setTestsData(response.data.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();

  }, []);
  if (testsData.length === 0) {
    return <><TwoRowThreeColumnLayout /></>
  }

  const cards = testsData
  return (
    <>
      <SeoHelmets 
        title="UPSC Civil Services Courses" 
        description="Explore our comprehensive Civil Services courses designed to help you ace the UPSC exam. Top-tier coaching and materials from Insight IAS."
        keywords="UPSC courses, IAS coaching, civil services preparation, Insight IAS Delhi"
      />
      <div>
        <CardsPage cards={cards} heading={civilheading} />
      </div>
    </>
  )
}

export default CivilsCard;